export default __webpack_public_path__ + "static/telehealth-solutions-rural-healthcare-1eec0f9b83b23c62628251f7165a82af.jpg";